import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate'

import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    getPendingforallocationList as pendingshipmentList,
    AllocatedShipmentDetails as AllocatedFwdShipmentDetails,
    ClientNameList as ClientNameList,
    validateEODAllocation as EODValidation,
    TriDetails as GetTripdetails,
    AllocateShipment as AllocateShipment,
    PreviousDayShipment as PreviousDayShipmentDetails,
    GetHubFlags1 as GetHubFlags2,
    CloseTrip1 as CloseTrip,
    PendingList as PendingList2,
    ServiceType as ServiceType1,
    VehicleList1 as VehicleList,
    CreateTrip as CreateTrip,
    GetSubcluster as SameRouteShipments,
    GetEscalation1 as GetEscalation,
    ShipmentConfirm as ConfirmShipment,
    ShipmentPrintDetails1 as ShipmentPrintDetails,
    pdfData1 as pdfData,
    getUnallocatedShipmentsByShipmentType as getUnallocatedShipments,
    RemoveAllocatedShipment1 as RemoveAllocatedShipment,
    GetShipmentCount1 as GetShipmentCount,
    SubmitReason1 as StoreReason,
    SeqofNonAllocation as GetNonAllocationSEQ,
    GetClusterId as GetClusterIdList,
    GetBikeVehicleList as BikeVehicleList
} from '../../../../../services/modules/newallocationservices.js'


import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments

    },
    mixins: [PageTracker],
    data: function () {
        return {
            userHubIdArr: [],
            value: false,
            PDDPopup: false,
            vehiclePopup: false,
            currentScreenTab: 'ALL',
            CourierCompanyID: '',
            IsSRNeedTrip: false,
            isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            EmpType: '',
            SRSelectingloader: false,
            srArrayList: [],
            srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            clientList: [],
            clientArrayList: [],
            Clientname: '',
            ClientObj: {
                value: "",
                text: ""
            },
            Clientname2: '',
            ClientObj2: {
                value: "",
                text: ""
            },
            ClientLoader: '',
            ServiceType: '',
            ServiceTypeArrayList: [],
            ServiceTypeList: [],
            ServiceTypeObj: {
                value: "",
                text: ""
            },
            ServiceLoader: false,
            WeightGroup: '',
            WeightGList: [{
                    value: "0,1",
                    text: "All"
                },
                {
                    value: "1",
                    text: "Heavies"
                },
                {
                    value: "0",
                    text: "Regular"
                },
            ],
            WeightGObj: {},
            EscalationLoader: '',
            Escalation: '',
            EscalationList: [],
            EscalationListArrayList: [],
            EscalationObj: {
                value: "",
                text: ""
            },
            ClusterLoader: '',
            ClusterId: '',
            ClusterList: [],
            ClusterArrayList: [],
            ClusterObj: {
                value: "",
                text: ""
            },
            shipmentNo: '',
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],
            UnallocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingId",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "PDD Date",
                    key: "PDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Shipment Type",
                    key: "ServiceType",
                },
                {
                    label: "Payment Mode",
                    key: "OrderType",
                },
                {
                    label: "Amt",
                    key: "NetPayment",
                },
                // {
                //     label: "Cluster ID",
                //     key: "subclusterid",
                // },
                {
                    label: "SubCluster Name",
                    key: "subclustername",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            AllocatedList: [],
            AllocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "EDD Date",
                    key: "EDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Shipment Type",
                    key: "ServiceType",
                },
                {
                    label: "Pincode",
                    key: "ShipPincode",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SuggestionList: [],
            SuggestionColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "EDD date",
                    key: "EDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "PDD date",
                    key: "PDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteList: [],
            startAllocationFlag: false,
            AllocateLoading: false,
            isAllocation: false,
            isConfirmLoad: false,
            dismissSecs: 20,
            dismissCountDown: 0,
            allocationErrorMsg: "",
            dismissCountDownSuccess: 0,
            allocationSuccessMsg: "",
            flagShowPreviousShipment: false,
            showShipmentModel: false,
            isPodsLoader: false,
            PendingList: [],
            showGroupIdShipmentModel: false,
            showParentGroupIdShipmentList: [],
            pendingGrouptErrorMsg: '',
            IsLongPinCodeFlag: null,
            ebnVehicleNo: '',
            errEbnVehicleNo: '',
            flagShowEbnVehicleNo: false,
            closeTripModel: false,
            startTripFlag: false,
            tripId: '',
            openKmImg: '',
            openKm: '',
            closeKmImg: '',
            closeKm: '',
            errorOpenKM: '',
            errorCloseKM: '',
            originCloseImg: '',
            srVehicleNo: '',
            tripTitle: 'Start Trip',
            tripCreatedDate: '',
            currentDateTime: '',
            tripDayflag: 0,
            tripDateFlag: false,
            vehicleTypeFlag: false,
            vehicleNo: '',
            vehicleOpenKM: '',
            errVehicleNo: '',
            vehicleTypeFlag: false,
            vehicleType: '',
            srVehicleList: [],
            vehicleNoItemObj: {
                value: '',
                text: ''
            },
            errVehicleKm: '',
            isVehicleReplacedCheck: 0,
            isVehicleReplaced: false,
            vehicleVendorId: '',
            allocationLoader: false,
            PrintShipmentModal: false,
            batchCreatedDate: '',
            PrintShipmentsList: [],
            PrintShipmentsColumns: [{
                    label: "Delivery User",
                    key: "SrName",
                },
                {
                    label: "Created Date",
                    key: "CreatedDate",
                },
            ],
            ShowPrintTable: false,
            isLoadPDF: false,
            isLoadBatch: false,
            shippingIDArray: [],
            ResCreatedDate: '',
            EnableHyperLink: false,
            unallocatePageNumber: 1,
            unallocatePageLimit: 10,
            unallocateTotalCount: 0,
            unallocatepageCount: 1,
            AccAWBNumbers: '',
            showAllocatedShipmentsList: [],
            srallocatePageNumber: 1,
            srAllocatedTotalCount: 0,
            srAllocatedPageCount: 1,
            srAllocatedPageLimit: 10,
            huballocatePageNumber: 1,
            hubAllocatedTotalCount: 0,
            hubAllocatedPageCount: 0,
            hubAllocatedPageLimit: 10,
            IsAllData: true,
            Tobeattempted: false,
            Pddbreached: false,
            Pddbreachedinnext24hours: false,
            FakeAttempt: false,
            disableprint: false,
            AllCount: 0,
            pddBreachedCount: 0,
            PDDBreachedinNext24hrsCount: 0,
            fakeAttemptsCount: 0,
            tobeAttemptedTodayCount: 0,
            NonAllocationRsn: false,
            Reason: '',
            ReasonList: [],
            ReasonObj: {
                text: ""
            },
            hideAllocateFlag: false,
            TopReset: true,
            AllocateTableLoader: false,
            PDTableLoader: false,
            SMTableLoader: false,
            UATableLoader: false,
            HUbAllocatedTableLoader: false,
            CountLoading: false,
            TitleName: '',
            arrReasonList: [],
            BucketName: '',
            fromList: [{
                value: "UA",
                text: "From Mobile"
            }, {
                value: "Web",
                text: "From Web"
            }],
            fromItemObj: {
                value: "UA",
                text: "From Mobile"
            },
            fromId: "UA",
            vehicleNoRegExp : /^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$/,
            ResetLoader:false,
            resultCount: 0,
            SEQShippingids: [],
            allocationMsgprexo :{},
            userDataKey : '',
            hubCODPendingLimit: '',
            IsPendingCODBlock: false,
            isShowCODAmount: false,
            srCODPendingMsg: '',
            dismissCountDownCOD: 0
        };
    },
    filters: {
        batchCreatedDateFormat: function (date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        await this.GetHubFlags(this.userHubId);
        this.GetDeliverySRList(this.userHubId);
        this.GetClientList();
        this.GetServiceTypeList();
        this.GetClusterIds();
        this.GetEscalation();
        this.loadUnallocatedShipmentsList();
        this.GetCount();
        this.loadAllocatedShipmentListInHub()
        // this.vehicleNoRegExp = new RegExp('^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$');
    },
    methods: {
        async selectSR(obj) {
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.isAllocation = false
            this.hideAllocateFlag = true;
            this.shipmentNo = ''
            this.ebnVehicleNo = '',
                this.errEbnVehicleNo = '',
                this.flagShowEbnVehicleNo = false,
                this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;
            this.OldUserid = obj.OldUserid;
            this.EmpType = obj.EmpType;
            this.CourierCompanyID = obj.CourierCompanyID;
            this.MobileNumber = obj.MobileNumber;
            this.IsSRNeedTrip = obj.IsSRNeedTrip;
            this.vehicleTypeFlag = false;
            this.tripDayflag = 0;
            this.disableprint = true;
            this.isShowCODAmount = false;
            this.srCODPendingMsg = '';

            const eodShipValidation = await this.validateEODAllocation();
            if(eodShipValidation || obj.isCodLimitBreached){
                if(obj.isCodLimitBreached && !eodShipValidation){
                    this.isShowCODAmount = true;
                    this.dismissCountDownCOD = this.dismissSecs;
                    this.srCODPendingMsg = `<span style="color: red;"> Pending amount on SR: ${obj.codPendingAmt} <br/> Pending Amount Limit: ${this.hubCODPendingLimit} </span>`
                }
                let alertMsg = eodShipValidation ? eodShipValidation : 'Please clear the pending COD Amount against the user and try again.';
                this.hideAllocateFlag = false;
                return this.$alertify.error(alertMsg);
            }
            if (this.EmpType == null || this.EmpType == "") {
                this.$alertify.error("EmpType not found against this SR, EmpType is required.")
            } else if (this.IsSRNeedTrip == true) {
                this.TopReset = false
                this.IsSRNeedTrip = true
                this.tripDayflag = 0;
                this.SRSelectingloader = true;
                this.vehicleType = ""
                this.srVehicleList = []
                this.vehicleNoItemObj = {
                    value: '',
                    text: ''
                }
                this.vehicleOpenKM = ''
                this.vehicleNo = ''
                this.vehicleVendorId = 0
                this.startAllocationFlag = false
                this.tripTitle = 'Start Trip'
                this.errorCloseKM = ''
                this.errorOpenKM = ''
                this.closeKm = ''
                this.tripState = ''
                this.ValiadteTripdetails();
            }
            this.AllocatedFwdShipmentData();
            this.PreviousDayShipmentList();
            //this.SameRouteShipmentList();
        },
        GetDeliverySRList(hubid) {
            this.srLoader = this.loader;
            this.srArrayList = [];
            this.srList = [];
            let payload = {
                "usertype": "3",
                "hubid": [hubid],
                "isCODApiCall": this.IsPendingCODBlock ? true : false,
            }
            getHubDeliverySRListByHubID(payload, (result) => {
                this.srArrayList = result.data.data.results;
                for (var i = 0; i < this.srArrayList.length; i++) {
                    const srCODPendingAmt = this.srArrayList[i].codPendingAmount;
                    const isDayAllocationDone = this.srArrayList[i].IsDayAllocationDone;
                    let CodLimitBreachedFlag = !isDayAllocationDone && this.hubCODPendingLimit != null && srCODPendingAmt > 0 && srCODPendingAmt > this.hubCODPendingLimit;   
                    
                    this.srList.push({
                        value: this.srArrayList[i].userid,
                        text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                        OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
                        EmpType: this.srArrayList[i].EmpType,
                        CourierCompanyID: this.srArrayList[i].CourierCompanyID,
                        MobileNumber: this.srArrayList[i].MobileNumber,
                        IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR,
                        isCodLimitBreached: CodLimitBreachedFlag,
                        codPendingAmt: srCODPendingAmt
                    })
                }
                this.srLoader = '';
            })
        },
        selectFrom(obj) {
            this.fromItemObj = obj
            this.fromId = obj.value
        },
        GetHubFlags() {
            return new Promise((resolve, reject) => {
                let HubFlagsPayload = {
                    "Outsourceid": 4,
                    "hubid": this.userHubId
                }
                GetHubFlags2(HubFlagsPayload, (result) => {
                    if (result.data.data.code == 200) {
                        this.isRSVSr = result.data.data.data.IsRSVSr;
                        const hubCodLimit = result.data.data.data.configSetting.CODPendingLimit;
                        this.hubCODPendingLimit = (hubCodLimit && hubCodLimit != 0) ? hubCodLimit : null;
                        this.IsPendingCODBlock = result.data.data.data.configSetting.IsPendingCODBlock
                    } else {
                        this.$alertify.error(result.data.data.message)
                    }
                    resolve(true);
                })
            })
        },
        selectClient(obj) {
            this.ClientObj = obj;
            this.Clientname = obj.value
        },
        GetClientList() {
            this.ClientLoader = this.loader;
            let payload = {}
            ClientNameList(payload, (result) => {
                this.clientArrayList = result.data.data;
                for (let i = 0; i < this.clientArrayList.length; i++) {
                    this.clientList.push({
                        value: this.clientArrayList[i].ClientMasterID,
                        text: `${this.clientArrayList[i].CompanyName}`
                    })
                }
                this.ClientLoader = '';
            })
        },
        selectServiceType(obj) {
            this.ServiceTypeObj = obj;
            this.ServiceType = obj.text
        },
        GetServiceTypeList() {
            this.ServiceLoader = this.loader;
            let payload = {
                "serviceTypeValuesRequired": true
            }
            ServiceType1(payload, (result) => {
                this.ServiceTypeArrayList = result.data.data.serviceType;
                for (let i = 0; i < this.ServiceTypeArrayList.length; i++) {
                    this.ServiceTypeList.push({
                        text: `${this.ServiceTypeArrayList[i]}`
                    })
                }
                this.ServiceLoader = '';
            })
        },
        selectWeightG(obj) {
            this.WeightGObj = obj;
            this.WeightGroup = obj.text
        },
        selectEscalation(obj) {
            this.EscalationObj = obj;
            this.Escalation = obj.text
        },
        GetEscalation() {
            this.EscalationLoader = this.loader;
            let payload = {}
            GetEscalation(payload, (result) => {
                this.EscalationListArrayList = result.data.data;
                for (let i = 0; i < this.EscalationListArrayList.length; i++) {
                    this.EscalationList.push({
                        text: `${this.EscalationListArrayList[i]}`
                    })
                }
                this.EscalationLoader = '';
            })
        },

        selectCluster(obj) {
            this.ClusterObj = obj;
            this.ClusterId = obj.text
        },
        GetClusterIds() {
            let payload = {
                "hubid": this.userHubId,
            }
            GetClusterIdList(payload, (result) => {
                this.ClusterArrayList = result.data.data;
                for (let i = 0; i < this.ClusterArrayList.length; i++) {
                    this.ClusterList.push({
                        value: this.ClusterArrayList[i].clusterId,
                        text: `${this.ClusterArrayList[i].clusterName}`,
                    })
                }
            })
        },
        async validateEODAllocation() {
            return new Promise((resolve, reject)=>{
                let EODvalidationdata = {
                    "DeliveryUserID": this.SrId,
                    "HubID": this.userHubId
                }
                EODValidation(EODvalidationdata, (result) => {
                    if (result.data.code === 202) {
                        this.hideAllocateFlag = false;
                        resolve(result.data.message);
                    } else {
                        this.hideAllocateFlag = true;
                        resolve(false);
                    }
                    this.TopReset = false
                })
            })
        },
        ValiadteTripdetails() {
            let TripDetailsPayload = {
                "XBkey": "XB123",
                "HubId": this.userHubId,
                "DeliveryUserId": this.SrId
            }
            GetTripdetails(TripDetailsPayload, (result) => {
                if (result.data.TripState == "closed") {
                    this.tripState = 'created'
                    this.startTripFlag = true
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "created" || result.data.TripState == "start") {
                    this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
                    this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
                    if (this.tripCreatedDate == this.currentDateTime) {
                        this.tripDayflag = 0;
                        this.tripDateFlag = false;
                    } else {
                        this.tripDayflag = result.data.tripDayflag
                        this.tripDateFlag = true;
                    }
                    this.startTripFlag = true
                    this.tripState = result.data.TripState
                    this.tripTitle = "Continue trip"
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "deliveryuserclosed" && result.data.code == 200) {
                    this.openKM = result.data.OpenKM
                    this.openKmImg = result.data.OpenKMImageUrl
                    this.closeKmImg = result.data.CloseKMImagUrl
                    this.originCloseImg = result.data.CloseKMImagUrl
                    this.tripId = result.data.TripId
                    this.srVehicleNo = result.data.VehicleNo
                    this.openKm = result.data.OpenKM
                    this.closeTripModel = true
                    this.SRSelectingloader = false;
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                }
            }, error => {
                console.error(error)
            })
        },
        startTrip() {
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            if (this.tripTitle == 'Start Trip') {
                this.vehicleTypeFlag = true
            } else {
                this.startAllocation(false)
            }
        },
        selectVehicleNo(obj) {
            this.vehicleNoItemObj = obj
            this.vehicleNo = obj.text
            this.vehicleVendorId = obj.value
        },
        loadVehicleDetails(type) {
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.startAllocationFlag = false
            this.vehicleType = type
            this.srVehicleList = []
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleOpenKM = ''
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if(type=="bike") {
                let payload = {
                  "srid":this.SrId,
                  "hubid":this.userHubId
                }
                BikeVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        var srVehicleList = result.data.data.data
                        for (var i = 0; i < srVehicleList.length; i++) {
                          this.srVehicleList.push({text:srVehicleList[i].VehicleNumber})
                        }
                    }
                })
              } else if(type=="vehicle") {
            let payload = {
                "HubId": this.userHubId
            }
            VehicleList(payload, (result) => {
                if (result.data.data.ResultCode == 100) {
                    if (type == "vehicle") {
                        var srVehicleList = result.data.data.Data
                        for (var i = 0; i < srVehicleList.length; i++) {
                            this.srVehicleList.push({
                                value: srVehicleList[i].VendorVehicleId,
                                text: srVehicleList[i].VehicleNumber
                            })
                        }
                    }
                }
            })
        }
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        startAllocation(flag) {
            this.flagShowPreviousShipment = false
            this.startAllocationFlag = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            var decimal = /^\d+(\d{1,2})?$/;
            if (decimal.test(this.vehicleOpenKM) == false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
                this.errVehicleKm = "Enter Correct KM"
            } else if (this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
            } else if (decimal.test(this.vehicleOpenKM) == false && flag) {
                this.errVehicleKm = "Enter Correct KM"
            } else if (flag && this.vehicleOpenKM > 1000000) {
                this.errVehicleKm = "Open Km should be less than 1000000"
            } else {
                this.startAllocationFlag = true
                if (flag) {
                    this.TripCreation();
                }
            }
        },
        TripCreation() {
            this.allocationLoader = true;
            let payload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "Delivery",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "operationType": "lastmile"
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                payload['isvehicleupdated'] = true
            } else {
                payload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                payload['vehiclevendorid'] = this.vehicleVendorId
            }
            CreateTrip(payload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "createTrip",
                            "srname": this.SrName,
                            "triptype": "Delivery",
                            "hubid": this.userHubId
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.startAllocationFlag = true;
                    this.$alertify.success(result.data.message);

                } else if (result.data.code == 202) {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                } else {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                }
                this.allocationLoader = false;
            }, error => {
                this.startAllocationFlag = false;
                this.$alertify.error('Failed to Create Trip, Please retry!');
                this.allocationLoader = false;
                console.error(error)
            })
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        loadOpenImageError(imageSrc, type) {
            var srcLink = "static/img/defaultImg.png"
            this.openKmImg = srcLink
        },
        loadCloseImageError(imageSrc) {
            var srcLink = "static/img/defaultImg.png"
            this.originCloseImg = imageSrc
            this.closeKmImg = srcLink
        },
        verifyTrip() {
            if (this.openKm >= 1000000) {
                this.errorOpenKM = "Open Km should be less than 1000000";
            } else {
                this.errorOpenKM = '';
                if (parseFloat(this.closeKm) > parseFloat(this.openKm)) {
                    let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
                    if (calculatekm < 200) {
                        this.errorCloseKM = '';
                        let payload = {
                            "XBkey": "XB123",
                            "tripid": this.tripId,
                            "sruserid": this.SrId.toString(),
                            "hubid": this.userHubId,
                            "km": this.closeKm,
                            "Openkm": this.openKm,
                            "tripstate": "closed",
                            "vehicleno": this.srVehicleNo,
                            "isvehiclereplaced": false,
                            "lastmodifiedby": this.createdBy,
                            "operationType": "lastmile"
                        }
                        CloseTrip(payload, (result) => {
                            if (result.data.code == 200) {
                                let TrackerInfo = {
                                    projectname: "Last Mile",
                                    type: "Web",
                                    userid: this.userid,
                                    username: this.createdBy,
                                    meta: {
                                        "event": "closeTrip",
                                        "tripid": this.tripId,
                                        "sruserid": this.SrId.toString()
                                    }
                                }
                                this.PageTracker(TrackerInfo);
                                this.$alertify.success(result.data.message)
                                //   this.resetTrip()
                                this.closeTripModel = false
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        })
                    } else {
                        this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
                    }
                } else {
                    this.errorCloseKM = "Close KM should be greater then open KM"
                }
            }
        },
        closeCloseTripModel() {
            this.closeTripModel = false
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChangedCOD(dismissCountDownCOD){
            this.dismissCountDownCOD = dismissCountDownCOD
        },
        countDownChangedSuccess(dismissCountDownSuccess) {
            this.dismissCountDownSuccess = dismissCountDownSuccess
        },
        loadAllocatedDetails() {
            this.AllocatedFwdShipmentData();
        },
        Allocate() {
            if (this.flagShowEbnVehicleNo == true) {
                if (this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase()) == false) {
                    return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
                }
                else{
                    this.errEbnVehicleNo = ''
                }
            }
            var tempStr = this.shipmentNo;
            this.AllocateLoading = true;
            let AllocatePayload = {
                "isAllocationFrom": 'New',
                "XBkey": "XB123",
                "HubId": this.userHubId.toString(),
                "DeliveryUserId": this.SrId,
                "OldDeliveryUserOrUserId": this.OldUserid.toString(),
                "DeliveryUserName": this.SrName,
                "ShippingID": (this.shipmentNo).trim(),
                "LastModifiedBy": this.createdBy,
                "IsConfirmAllocation": false,
                "AllocationType": "Delivery",
                "EmpType": this.EmpType ? this.EmpType : "",
                "MarkedFrom": "Web",
                "CourierCompanyID": this.CourierCompanyID ? this.CourierCompanyID.toString() : 'null',
                "IsRSVCSr": this.isRSVSr,
                "MobileNo": this.MobileNumber ? this.MobileNumber.toString() : "",
                "isTripAllowedForSR": this.IsSRNeedTrip,
                "vehicleno": this.ebnVehicleNo
            }
            AllocateShipment(AllocatePayload, (result) => {
                if (result.data.code == 200) {
                    //Hundle Prexo shipment Success
                    this.allocationMsgprexo  = result.data.prexoShipment ? ('This is PREXO shipment and its related RVP shipment is :-'+ result.data.prexoShipment): null;
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            routeurl: "expose/shipment/allocate",
                            meta: {
                                event: "shipmentAllocation",
                                shipmentId: this.shipmentNo ? this.shipmentNo.trim().toString() : null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, AllocatePayload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                    this.isAllocation = true;
                    // this.AllocatedFwdShipmentData();
                    this.loadAllocatedShipmentListInHub();
                    this.loadUnallocatedShipmentsList();
                    this.GetCount();
                    this.shipmentNo = '';
                    this.$refs.shipmentNo.focus();
                    this.dismissCountDownSuccess = 20;
                    this.allocationSuccessMsg = tempStr + " :- " + result.data.message;
                    this.flagShowEbnVehicleNo = false;
                    this.ebnVehicleNo = '';
                    this.errEbnVehicleNo = '';
                    // this.ebnVehicleNo = '';
                    if (typeof result.data.status != undefined && result.data.status == 206 && result.data.data.length > 1) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.mpsErrormsg;
                        let pendingMPSData = result.data.data
                        this.showParentGroupIdShipmentList = pendingMPSData.filter(obj => obj != tempStr);
                    }
                } else {
                    if (typeof result.data.status != undefined && result.data.status == 204) {
                        this.flagShowPreviousShipment = true
                    }
                    if (typeof result.data.status != undefined && result.data.status == 207) {
                        this.flagShowEbnVehicleNo = true;
                        this.shipmentNo = tempStr;
                        this.$refs.ebnVehicleNo.focus();
                    }

                    if (typeof result.data.status != undefined && result.data.status == 209) {
                        this.ReAttemptLongPincodeAllocation(result);
                    }
                    this.$refs.shipmentNo.focus();
                    this.dismissCountDown = 20
                    this.allocationErrorMsg = result.data.message != '' && result.data.message != undefined ? `${tempStr} :-  ${result.data.message}` : `${tempStr} :- Not getting any response message.`

                    //Hundle Prexo shipment error
                    this.allocationMsgprexo  = result.data.prexoShipment ? ('This is a PREXO shipment, and its associated RVP shipment is :-'+ result.data.prexoShipment): null;

                }
                this.AllocateLoading = false;
            })
        },
        selectReason(obj) {
            this.ReasonObj = obj;
            this.Reason = obj.text
        },
        CheckPDD() {
            this.CloseNonAllocationRsn()
            let Payload = {
                "DeliveryUserId": this.SrId,
                "HubId": this.userHubId.toString(),
                "shipmenttype": "Delivery",
            }
            GetNonAllocationSEQ(Payload, (result) => {
                if (result.data.code == 200 && result.data.data.length > 0) {
                    this.SeqArray = result.data.data.filter(x => (x.result != 0))
                    this.BucketName = this.SeqArray[0].Bucket
                    this.TitleName = this.SeqArray[0].title
                    this.resultCount = this.SeqArray[0].result
                    this.SEQShippingids = this.SeqArray[0].shippingids
                    this.arrReasonList = this.SeqArray[0].Reason.split(",")
                    for (let i = 0; i < this.arrReasonList.length; i++) {
                        this.ReasonList.push({
                            text: this.arrReasonList[i],
                        })
                    }
                    this.NonAllocationRsn = true
                } else {
                    this.confirmTrip();
                    this.CloseNonAllocationRsn()
                }
            })
        },
        StoreNonAllocationSeq() {
            this.CloseNonAllocationRsn();
            this.TitleName = this.SeqArray[0].title
            this.BucketName = this.SeqArray[0].Bucket
            this.resultCount = this.SeqArray[0].result
            this.SEQShippingids = this.SeqArray[0].shippingids
            this.arrReasonList = this.SeqArray[0].Reason.split(",")
            for (let i = 0; i < this.arrReasonList.length; i++) {
                this.ReasonList.push({
                    text: this.arrReasonList[i],
                })
            }
            this.NonAllocationRsn = true
        },
        CloseNonAllocationRsn() {
            this.BucketName = ''
            this.TitleName = ''
            this.Reason = ''
            this.ReasonObj = {
                text: ""
            }
            this.resultCount = 0,
            this.SEQShippingids =[]
            this.ReasonList = []
            this.NonAllocationRsn = false
        },
        SubmitNonAllocationRsn() {
            let Payload = {
                "DeliveryUserId": this.SrId,
                "Reason": this.Reason,
                "Bucket": this.BucketName,
                "CreatedBy": this.createdBy,
                "shippingids": this.SEQShippingids,
                "pendingcount": this.resultCount
            }
        StoreReason(Payload, (result) => {
                if (result.data.code == 200) {
                    this.$alertify.success("Reason Submitted Successfully!!")
                    this.CloseNonAllocationRsn();
                    this.SeqArray.splice(0, 1)
                    if (this.SeqArray.length > 0) {
                        this.StoreNonAllocationSeq();
                    } else {
                        this.confirmTrip();
                    }
                } else if (result.data.code == 204) {
                    this.$alertify.error('Reason is required.')
                }
            })
        },
        async confirmTrip() {
            this.allocationSuccessMsg = ''
            this.isConfirmLoad = true;
            this.showParentGroupIdShipmentList = [];
            let payload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "Delivery",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "LastModifiedBy": this.createdBy,
                "MarkedFrom": this.fromId,
                "operationType": "lastmile",
                "isHandoverDeliveryUser": 1
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                payload['isvehicleupdated'] = true
            } else {
                payload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                payload['vehiclevendorid'] = this.vehicleVendorId
            }
            ConfirmShipment(payload, (result) => {
                if (result.data.code == 200) {
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            routeurl: "expose/shipment/confirm",
                            meta: {
                                event: "expose-shipment-confirm",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, payload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                    this.isAllocation = false
                    this.$alertify.success(result.data.message)
                    this.AllocatedFwdShipmentData();
                    this.loadAllocatedShipmentListInHub();
                    this.fromId = "UA";
                    // this.resetTrip()
                } else {
                    if (result.data.status == 208) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.message;
                        this.showParentGroupIdShipmentList = result.data.data;
                    } else {
                        this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                    }
                }
                this.isConfirmLoad = false;
            }, error => {
                console.error(error)
                this.isConfirmLoad = false;
            })
        },
        ReAttemptLongPincodeAllocation() {
            let message = {
                title: '',
                body: `<p><b>This shipment belongs to Long Pincode. Do you want to allocate it?</b></p>  <p style="color:green">Click <b> YES</b> to Attempt Delivery. <br/> <span style="color:red"> Press <b> No </b> to Hold the Shipment.</span> </p>`,
            };
            let res = this.$dialog.confirm(message, {
                    html: true,
                    animation: 'bounce',
                    backdropClose: false,
                    okText: 'Yes',
                    cancelText: 'No',
                    reverse: true
                })
                .then(dialog => {
                    this.IsLongPinCodeFlag = true;
                    this.Allocate();
                })
                .catch((e) => {
                    this.IsLongPinCodeFlag = false;
                    this.Allocate();
                })
        },
        ShowPendingShipments() {
            this.showShipmentModel = true
            this.isPodsLoader = true;
            this.PendingList = []
            let PendingPayload = {
                "DeliveryUserId": this.SrId
            }
            PendingList2(PendingPayload, (result) => {
                if (result.data.code == 200) {
                    this.PendingList = result.data.data
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
                this.isPodsLoader = false;
            })
        },
        srAllocatedPagination(pageNum) {
            this.srallocatePageNumber = pageNum;
            this.AllocatedFwdShipmentData();
        },
        AllocatedFwdShipmentData() {
            this.isAllocation = false
            this.AllocateTableLoader = true
            this.AllocatedList = []
            this.srAllocatedTotalCount = 0
            let AllocatedShipmentPayload = {
                "HubId": this.userHubId.toString(),
                "ShipmentType": 'Delivery',
                "DeliveryUserId": this.SrId,
                "pageNumber": this.srallocatePageNumber,
                "pageLimit": this.srAllocatedPageLimit
            }
            AllocatedFwdShipmentDetails(AllocatedShipmentPayload, (result) => {

                if (result.status == 200 && result.data.code == 200) {
                    this.AllocatedList = result.data.data.rows
                    if (this.AllocatedList.length > 0) {
                        this.isAllocation = true
                    }
                    this.srAllocatedTotalCount = result.data.data.count;

                    if (this.srAllocatedTotalCount < this.srAllocatedPageLimit) {
                        this.srAllocatedPageCount = 1
                    } else {
                        this.srAllocatedPageCount = Math.ceil(this.srAllocatedTotalCount / this.srAllocatedPageLimit);
                    }
                    this.AllocateTableLoader = false
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "exposeallocationapis/get/allocated/shipments/List",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "exposeallocationapis-get/allocated-shipments-List",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, AllocatedShipmentPayload);
                        this.PageTracker(TrackerInfo);
                    }
                    catch (error) {
                        console.log(error);
                    }
                } else if (result.status == 200 && result.data.code != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                } else if (result.status != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                }
            })
        },
        loadAllocatedShipmentListInHub() {
            this.HUbAllocatedTableLoader = true
            this.showAllocatedShipmentsList = []
            this.hubAllocatedTotalCount = 0
            let reqAllocatePayload = {
                "HubId": this.userHubId.toString(),
                "ShipmentType": 'Delivery',
                "pageNumber": this.huballocatePageNumber,
                "pageLimit": this.hubAllocatedPageLimit
            }

            AllocatedFwdShipmentDetails(reqAllocatePayload, (result) => {
                if (result.status == 200 && result.data.code == 200) {
                    this.showAllocatedShipmentsList = result.data.data.rows
                    this.hubAllocatedTotalCount = result.data.data.count;

                    if (this.hubAllocatedTotalCount < this.hubAllocatedPageLimit) {
                        this.hubAllocatedPageCount = 1
                    } else {
                        this.hubAllocatedPageCount = Math.ceil(this.hubAllocatedTotalCount / this.hubAllocatedPageLimit);
                    }
                    this.HUbAllocatedTableLoader = false
                } else if (result.status == 200 && result.data.code != 200) {
                    this.hubAllocatedTotalCount = 0
                    this.hubAllocatedPageCount = 1
                    this.HUbAllocatedTableLoader = false
                } else if (result.status != 200) {
                    this.hubAllocatedTotalCount = 0
                    this.hubAllocatedPageCount = 1
                    this.HUbAllocatedTableLoader = false
                }
            })
        },
        hubAllocatedPagination(pageNum) {
            this.huballocatePageNumber = pageNum;
            this.loadAllocatedShipmentListInHub();
        },
        RemoveShipment(shippingId) {
            let Payload = {
                XBkey: "XB123",
                ShippingID: shippingId,
                LastModifiedBy: this.createdBy,
            }
            RemoveAllocatedShipment(Payload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "RemoveShipment",
                            "ShippingID": shippingId.toString()
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.AllocatedFwdShipmentData()
                    this.loadAllocatedShipmentListInHub();
                    this.loadUnallocatedShipmentsList();
                    this.$alertify.success("Shipment Successfully Removed")
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
            }, error => {
                console.error(error)
            })
        },

        PreviousDayShipmentList() {
            this.PDTableLoader = true;
            this.SuggestionList = [];
            if(this.SrId == ''){
                this.PDTableLoader = false;
                }
            let PreviousDayPayload = {
                "HubId": (this.userHubId).toString(),
                "DeliveryUserId": this.SrId,
                "shipmenttype": "Delivery",
            }
            PreviousDayShipmentDetails(PreviousDayPayload, (result) => {
                this.SuggestionList = result.data.data;
                this.PDTableLoader = false;
            })
            this.PDTableLoader = false;
        },
        SameRouteShipmentList() {
            this.SMTableLoader = true
            this.SameRouteList = [];
            if(this.SrId == ''){
                this.SMTableLoader = false;
                }
            let SameRoutePayload = {
                "DeliveryUserId": this.SrId,
                "HubId": (this.userHubId).toString(),
                "shipmenttype": "Delivery",
            }
            SameRouteShipments(SameRoutePayload, (result) => {
                this.SameRouteList = result.data.data;
                this.SMTableLoader = false;
            })
            this.SMTableLoader = false;
        },

        PendingAllocationShipmentList() {
            let pendingShipmentPayload = {
                "HubID": this.userHubId,
                "ShipmentType": "Forward",
                "PageNo": 1
            }
            pendingshipmentList(pendingShipmentPayload, (result) => {
                // console.log('GET PENDING SHIPMENT LIST ---->>', result);
            })
        },
        HandleDragOver(event) {
            event.preventDefault();
        },
        OnlyNumber: function ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
                $event.preventDefault();
            }
        },
        OpenPrintShipmentModal() {
            this.PrintShipmentModal = true
            this.EnableHyperLink = false
        },
        closePrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentModal = false,
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        ResetPrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentsList = [],
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        GetShipmentPrintdetails() {
            this.PrintShipmentDetails();
            this.ShowPrintTable = true
        },
        PrintShipmentDetails() {
            this.PrintShipmentsList = [];
            this.isLoadBatch = true;
            let batchCdate = moment(this.batchCreatedDate).format('YYYY-MM-DD');
            this.today = new Date();
            let Today = moment(this.today).format('YYYY-MM-DD');
            if (batchCdate == Today) {
                this.EnableHyperLink = true;
            }
            let batchpayload = {
                "UserHubID": this.userHubId.toString(),
                "DeliveryUserID": this.SrId,
                "shipmentType": "Delivery",
                "createdDate": batchCdate
            }
            ShipmentPrintDetails(batchpayload, (result) => {
                if (result.data.code == 200) {
                    this.isLoadBatch = false
                    for (var i = 0; i < result.data.PrintBatchId.length; i++) {
                        this.shippingIDArray = []
                        for (var j = 0; j < result.data.PrintBatchId[i].NoOfShipments; j++) {
                            this.shippingIDArray.push({
                                shippingIDArray: result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                            })
                            this.ResCreatedDate = moment(result.data.PrintBatchId[i].ShippingIDs[j].CreatedDate).format('DD-MM-YYYY')
                        }
                        this.PrintShipmentsList.push({
                            AssignBatchNo: result.data.PrintBatchId[i].AssignBatchNo,
                            NoOfShipments: result.data.PrintBatchId[i].NoOfShipments,
                            shippingIDArray: this.shippingIDArray,
                            SrName: this.SrName,
                            CreatedDate: this.ResCreatedDate
                        })
                    }
                } else {
                    this.isLoadBatch = false
                    this.$alertify.error(result.data.message)
                }
            }, error => {
                console.error(error)
            })
        },
        exportCSVOfShippingIDS(result) {
            let csvContent = "data:text/csv;charset=utf-8,";
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            var today = dd + "" + mm + "" + yyyy;
            let filename = "ShippingID" + today + ".csv";
            csvContent += ['ShippingID',
                    ...result.map(item => Object.values(item).join(";"))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", filename);
            link.click();
        },

        PrintShipment(AssignBatchNo) {
            this.isLoadPDF = true
            this.input = {
                "DeliveryUserID": this.SrId,
                "ShipmentType": "Delivery",
                "BatchId": AssignBatchNo,
                "PrintType": "Delivery",
                "UserName": this.createdBy,
                "PrintFrom": 'FromWeb'
            }
            pdfData(this.input, (result) => {
                if (result.status == 200) {
                    const downloadUrl = window.URL.createObjectURL(new Blob([result.data], {
                        type: 'application/pdf'
                    }))
                    let message = {
                        title: '',
                        body: `<p>Pdf is generated, Would you like to open.!</p>`,
                    };

                    let res = this.$dialog.alert(message, {
                            html: true,
                            animation: 'bounce',
                            backdropClose: false,
                            loader: true
                        })
                        .then(dialog => {
                            window.open(downloadUrl);
                            this.isLoadPDF = false
                            dialog.close();
                        })
                        .catch(() => {
                            this.isLoadPDF = false
                        })
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "expose/web/get/shipmentbysrid",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "expose-web-get-shipmentbysrid",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, this.input);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    this.isLoadPDF = false;
                    this.$alertify.error('Unable to load pdf, Please try after sometime.!');
                }
            }, error => {
                this.isLoadPDF = false;
                console.error(error)
            })
        },
        GetCount() {
            this.CountLoading = true
            let RVPPayload = {
                "shipmenttype": "Delivery",
                "hubid": this.userHubId.toString()
            }
            GetShipmentCount(RVPPayload, (result) => {
                let CountARR = [];
                if (result.data.code == 200) {
                    CountARR = result.data.data[0]
                    this.AllCount = CountARR.all
                    this.tobeAttemptedTodayCount = CountARR.tobeAttemptedToday
                    this.pddBreachedCount = CountARR.pddBreached
                    this.PDDBreachedinNext24hrsCount = CountARR.PDDBreachedinNext24hrs
                    this.fakeAttemptsCount = CountARR.fakeAttempts
                    this.CountLoading = false
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                    this.CountLoading = false
                }
            })
        },
        Reset() {
            this.allocationSuccessMsg = ''
            this.dismissCountDown = 0,
                this.allocationErrorMsg = "",
                this.dismissCountDownSuccess = 0,
                this.srAllocatedTotalCount = 0
                this.TopReset = true,
                this.fromId = "UA",
                this.hideAllocateFlag = false;
            this.currentScreenTab = 'ALL',
                this.shipmentNo = ''
            this.ebnVehicleNo = '',
                this.errEbnVehicleNo = '',
                this.flagShowEbnVehicleNo = false,
                this.SuggestionList = [],
                this.SameRouteList = [],
                this.AllocatedList = [],
            this.disableprint = false
            this.SrId = ''
            this.SrName = ''
            this.srItemObj = {
                value: "",
                text: ""
            }
            this.AllocateTableLoader = false,
                this.AllocateTableLoader = false,
                this.PDTableLoader = false,
                this.SMTableLoader = false,
            this.currentDateTime = '',
                this.tripDayflag = '',
                this.tripCreatedDate = '',
                this.tripDateFlag = false,
                this.IsSRNeedTrip = false
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.tripTitle = 'Start Trip'
            this.isRSVSr = 0
            this.startTripFlag = false
            this.vehicleTypeFlag = false
            this.vehicleType = ""
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            this.vehicleOpenKM = ''
            this.startAllocationFlag = false
            this.isAllocation = false
            this.tripId = ''
            this.openKm = ''
            this.openKmImg = ''
            this.closeKm = ''
            this.closeKmImg = ''
            this.originCloseImg = ''
            this.srVehicleNo = ''
            this.errorCloseKM = ''
            this.errorOpenKM = ''
            this.flagShowPreviousShipment = false
            this.NonAllocationRsn = false
            this.ReasonObj = {
                text: ""
            }
            this.Reason = '',
            this.isShowCODAmount = false;
            this.srCODPendingMsg = '';
            this.$validator.reset();
            return true;
        },
        RightTabReset(){
            this.ResetLoader = true
            this.currentScreenTab = 'ALL',
            this.IsAllData = true;
            this.HUbAllocatedTableLoader = false,
            this.CountLoading = false
            this.IsAllData = true,
            this.Tobeattempted = false,
            this.Pddbreached = false,
            this.Pddbreachedinnext24hours = false,
            this.FakeAttempt = false
            this.Clientname = ''
            this.ClientObj = {
                value: "",
                text: ""
            }
            this.ServiceType = ''
            this.ServiceTypeObj = {
                value: "",
                text: ""
            }
            this.ClusterId = '',
            this.ClusterObj = {
                    value: "",
                    text: ""
                },
            this.WeightGroup = ''
            this.WeightGObj = {}
            this.Escalation = '',
            this.EscalationObj = {
                value: "",
                text: ""
            }
            this.AccAWBNumbers = ""
            this.loadUnallocatedShipmentsList();
            this.ResetLoader = false
        },
        unallocatedgetPaginationData(pageNum) {
            this.unallocatePageNumber = pageNum;
            this.loadUnallocatedShipmentsList();
        },
        async GetCurrentScreenValue(currentVal) {
            this.unallocatePageNumber = 1
            this.$refs.UnAllocatePaginate.selected= 0;
            this.currentScreenTab = currentVal;
            if (this.currentScreenTab == 'PDDBreached') {
                this.Pddbreached = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'TobeAttemptedToday') {
                this.Tobeattempted = true;
                this.IsAllData = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'PDDBreachedinNext24hrs') {
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = true;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'FakeAttempts') {
                this.FakeAttempt = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            } else {
                this.IsAllData = true;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            }
            this.loadUnallocatedShipmentsList();
        },

        loadUnallocatedShipmentsList() {
            let reqPayload = {
                "shipmenttype": "Delivery",
                "hubid": this.userHubId,
                "pagenumber": this.unallocatePageNumber,
                "pagelimit": this.unallocatePageLimit,
                "isAllData": this.IsAllData,
                "tobeattempted": this.Tobeattempted,
                "pddbreached": this.Pddbreached,
                "pddbreachedinnext24hours": this.Pddbreachedinnext24hours
            }
            if (this.AccAWBNumbers != "") {
                let shipingID = this.AccAWBNumbers.split(/[\s,]+/);
                let shipmentArray = [];
                $.each(shipingID, (key, AccAWBNumbers) => {
                    if (AccAWBNumbers != '') {
                        shipmentArray.push(AccAWBNumbers.trim())
                    }
                })
                reqPayload.shipmentid = shipmentArray;
            }
            if (this.Clientname) {
                reqPayload.clientid = this.Clientname
            }
            if (this.ServiceType) {
                reqPayload.servicetype = this.ServiceType
            }
            if (this.WeightGroup) {
                reqPayload.weightgroupid = this.WeightGroup
            }
            if (this.ClusterId) {
                reqPayload.clusterid = this.ClusterId
            }
            if (this.Escalation) {
                reqPayload.escalation = this.Escalation
            }
            this.getPendingShipmentforAllocation(reqPayload)
        },
        getPendingShipmentforAllocation(payloadobj) {
            this.UATableLoader = true
            this.showUnallocatedList = [];
            this.unallocateTotalCount = [];
            getUnallocatedShipments(payloadobj, (result) => {
                if (result.status == 200 && result.data.code == 200) {
                    this.showUnallocatedList = result.data.data
                    this.unallocateTotalCount = result.data.totalCount;

                    if (this.unallocateTotalCount < this.unallocatePageLimit) {
                        this.unallocatepageCount = 1
                    } else {
                        this.unallocatepageCount = Math.ceil(this.unallocateTotalCount / this.unallocatePageLimit);
                    }
                    this.UATableLoader = false
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "/exposeallocationapis/pending/allocationShipments/byShipmentType",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "pending-allocationShipments-byShipmentType",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, payloadobj);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else if (result.status == 200 && result.data.code != 200) {
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                } else if (result.status != 200) {
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }
            })
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/components/newallocationpage/forwardallocation/forwardallocation.js